import { useContext, useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';

import { AppContext } from '../scripts/context'

export default function Media() {

    const { page } = useParams();

    const {
    //MENU
        handleMenu,
    //CONTACT CONTAINER
        handleContactContainer,
    //WIDGET
        setWidgetState,
    //SCROLL
		scrollToTitle,
    //DETAIL
        setDetailWidgetState,
    //STYLE
        mediaStyleState,
        mediaLoaderContainerStyleState,
        setMediaLoaderContainerStyleState,
        mediaContainerOpacityState,
        mediaContainerVisibilityState,
        titleContainerStyleState,
        titleTextStyleState,
        buttonReadMoreStyleState
    } = useContext(AppContext);

    const mediaLoaderTimeoutRef = useRef();
    const mediaLoaderDelayTimeoutRef = useRef();
    const mediaLoaderIntervalRef = useRef();

    const contentMap = {
        home: {
            src: "/media/njbdesign_xthrust_0.webp",
            alt: "njbdesign_xthrust_0.webp",
            title: <div id="title">WELCOME</div>,
            text: <div id="title_text" style={titleTextStyleState}>Benefit from our expertise to <span className="nw">design timeless solutions</span></div>
        },
        digital: {
            src: "/media/suss_jetx_m_1.webp",
            alt: "suss_jetx_m_1.webp",
            title: <div id="title">DIGITAL</div>,
            text: <div id="title_text" style={titleTextStyleState}>Digital production to <span className="nw">make sense of reality</span></div>
        },
        games: {
            src: "/media/njbdesign_xthrust_1.webp",
            alt: "njbdesign_xthrust_1.webp",
            title: <div id="title">GAMES</div>,
            text: <div id="title_text" style={titleTextStyleState}>Independent projects and <span className="nw">unique assets that</span> <span className="nw">will keep you entertained</span></div>
        },
        design: {
            src: "/media/njbdesign_wristband_0.webp",
            alt: "njbdesign_wristband_0.webp",
            title: <div id="title">DESIGN</div>,
            text: <div id="title_text" style={titleTextStyleState}>Custom design and engineering <span className="nw">that reflects identity</span></div>
        },
        store: {
            src: "/media/njbdesign_store_0.webp",
            alt: "njbdesign_store_0.webp",
            title: <div id="title">STORE</div>,
            text: <div id="title_text" style={titleTextStyleState}>Back our ventures and <span className="nw">get selected products to</span> <span className="nw">represent our brands</span></div>
        }
    };

    const pageKeyMap = {
        undefined: "home",
        about: "home"
    };

    const pageKey = pageKeyMap[page] ?? page;

    const contentData = contentMap[pageKey];

    function handleReadMoreClick() {

        scrollToTitle("smooth");

    };

    function handleMediaClick() {

        handleMenu("collapse");
        handleContactContainer("collapse");
        setDetailWidgetState(false);
        setWidgetState(false);

    };

    function handleMediaOnLoad() {

        let mediaLoaderOpacity = 1

        clearTimeout(mediaLoaderDelayTimeoutRef.current);
        clearInterval(mediaLoaderIntervalRef.current);
    
        mediaLoaderDelayTimeoutRef.current = setTimeout(function() {

            mediaLoaderIntervalRef.current = setInterval(setMediaLoaderOpacity, 5);
            function setMediaLoaderOpacity() {
                if (mediaLoaderOpacity > 0) {
                    mediaLoaderOpacity = Math.max(mediaLoaderOpacity - 0.02, 0);
                    setMediaLoaderContainerStyleState(prevState => ({
                        ...prevState,
                        opacity: mediaLoaderOpacity
                    }));
                } else {
                    clearInterval(mediaLoaderIntervalRef.current);
                    setMediaLoaderContainerStyleState(prevState => ({
                        ...prevState,
                        visibility: "hidden"
                    }));
                };

            };

        }, 150);

    };

    //useEffect on mediaLoaderVisState change (mediaLoaderVisState gets set to visible on menu navigation)
    useEffect(() => {

        clearTimeout(mediaLoaderTimeoutRef.current);

        mediaLoaderTimeoutRef.current = setTimeout(function() {
            if (mediaLoaderContainerStyleState.visibility !== "hidden") {
                handleMediaOnLoad();
            };
        }, 2000);
                                                                        // eslint-disable-next-line
    }, [mediaLoaderContainerStyleState.visibility]);

    //useEffect on page param change
    useEffect(() => {

        clearTimeout(mediaLoaderDelayTimeoutRef.current);
        clearInterval(mediaLoaderIntervalRef.current);
                                                                        // eslint-disable-next-line
    }, [page]);

    return (
        <div id="media_container" style={{visibility: mediaContainerVisibilityState, opacity: mediaContainerOpacityState}}>
            <div id="media_container_content">
                <img id="media" style={mediaStyleState} onClick={handleMediaClick} onLoad={() => {handleMediaOnLoad()}} alt={contentData.alt} src={contentData.src}/>
            </div>
            <div id="media_loader_container" style={mediaLoaderContainerStyleState}></div>
            <div id="title_container" style={titleContainerStyleState}>
                {contentData.title}
                {contentData.text}
                <div id="button_read_more" style={buttonReadMoreStyleState} onClick={() => {handleReadMoreClick()}}>Read more...</div>
            </div>
        </div>
    );

};